import _objectWithoutProperties from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectDestructuringEmpty from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectDestructuringEmpty";
var _excluded = ["fillColor", "strokeColor", "strokeWidth", "size"];
import { jsx, Fragment } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { withSubcomponents } from '../utils.js';
var Path = function Path(_ref) {
  var args = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  return /* @__PURE__ */jsx(Fragment, {
    children: /* @__PURE__ */jsx("path", _objectSpread({
      d: "M14.2183 4.375C8.85123 4.375 4.48438 8.74142 4.48438 14.1098C4.48438 19.4769 8.85166 23.8438 14.2188 23.8438\n         C19.5867 23.8438 23.9531 19.4769 23.9531 14.1098C23.9527 8.74142 19.5867 4.375 14.2183 4.375ZM11.9259 12.8028\n         C12.3806 12.0075 13.2372 11.4711 14.2183 11.4711C15.6763 11.4711 16.8575 12.6523 16.8575 14.1102\n         C16.8575 15.5673 15.6758 16.7485 14.2183 16.7485C13.2364 16.7485 12.3806 16.2117 11.9259 15.4155\n         L9.76836 15.9506C10.491 17.697 12.2113 18.9248 14.2188 18.9248C15.9686 18.9248 17.4997 17.9916 18.3424 16.5963\n         L20.3424 17.094C19.2343 19.3599 16.9062 20.924 14.2188 20.924C10.461 20.924 7.4046 17.8671 7.4046 14.1102\n         C7.4046 10.3525 10.4606 7.29523 14.2188 7.29523C16.9062 7.29523 19.2343 8.85976 20.3424 11.1252L18.3424 11.6229\n         C17.4997 10.2276 15.9686 9.29396 14.2188 9.29396C12.2113 9.29396 10.4915 10.5222 9.76836 12.269L11.9259 12.8028Z"
    }, args))
  });
};
var ViewBox = "0 0 28 28";
var _Caldari = forwardRef(function (_ref2, ref) {
  var _ref2$fillColor = _ref2.fillColor,
    fillColor = _ref2$fillColor === void 0 ? "#00ACD1" : _ref2$fillColor,
    _ref2$strokeColor = _ref2.strokeColor,
    strokeColor = _ref2$strokeColor === void 0 ? "black" : _ref2$strokeColor,
    _ref2$strokeWidth = _ref2.strokeWidth,
    strokeWidth = _ref2$strokeWidth === void 0 ? 0 : _ref2$strokeWidth,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 28 : _ref2$size,
    rest = _objectWithoutProperties(_ref2, _excluded);
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    width: size,
    height: size,
    viewBox: ViewBox,
    fill: "none",
    paintOrder: "stroke"
  }, rest), {}, {
    children: /* @__PURE__ */jsx(Path, {
      fill: fillColor,
      stroke: strokeColor,
      strokeWidth: strokeWidth
    })
  }));
});
_Caldari.displayName = "Caldari";
var Caldari = withSubcomponents(_Caldari, {
  Path: Path,
  ViewBox: ViewBox
});
export { Caldari };